import { Component, HostBinding, Input } from '@angular/core';
import { Emphasis } from 'src/app/shared';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-button',
    template: `
    <button
      mat-flat-button
      class="text"
      [attr.role]="role"
      [ngClass]="{
        'high-emphasis': emphasis === 'High',
        'high-emphasis-disabled':
          emphasis === 'High' && (disabled || (disableWhenSubmit && loading)),
    
        'medium-emphasis': emphasis === 'Medium',
        'medium-emphasis-disabled':
          emphasis === 'Medium' && (disabled || (disableWhenSubmit && loading)),
        'low-emphasis': emphasis === 'Low',
        'low-emphasis-disabled':
          emphasis === 'Low' && (disabled || (disableWhenSubmit && loading)),
          'white-text': emphasis === 'High',
      }"
      [disabled]="disabled || (disableWhenSubmit && loading)"
      [attr.aria-label]="arialabel | translation: translationRequest"
      [type]="type"
      >
      <div class="tw-flex tw-items-center">
        @if (icon && !loading) {
          <mat-icon class="icon">{{ icon }}</mat-icon>
        }
        @if (loading && showSpinner) {
          <div
            class="tw-mr-2"
          [ngClass]="{
            'app-spinner-white': emphasis !== 'Low',
            'app-spinner-black':
              emphasis === 'Low' || disabled || (disableWhenSubmit && loading)
          }"
          ></div>
        }
        <div><ng-content></ng-content></div>
        @if (label) {
          <span>{{ label | translation: translationRequest }}</span>
        }
      </div>
    </button>
    `,
    styles: [
        `
      .text {
        font-weight: bold;
        letter-spacing: 0px;
        /* border-radius: 8px;*/
      }

      .icon {
        height: 18px;
        width: 18px;
        font-size: 18px;
        margin-right: 4px;
        margin-top: 1px;
      }
      .high-emphasis {
        background-color: var(--sed-dynamic-black-color);
        color: var(--sed-warm-white-color) !important;
        height: var(--mat-button-filled-container-height);
        border-radius: 20px;
        padding: 0 20px;
        transition: all 0.3s ease;

        &:hover:not(:disabled) {
          background-color: var(--sed-sedgwick-green-color) !important;
          color: #000000 !important;
          border: 1px solid var(--sed-dynamic-black-color);
        }
      }

      .white-text {
        color: var(--sed-warm-white-color) !important;
      }
      .high-emphasis-disabled {
        background-color: #f3f4f6 !important;
        color: #6b7280 !important;
        height: var(--mat-button-filled-container-height);
        border: 1px solid #9ca3af !important;
        cursor: not-allowed !important;
      }

      .low-emphasis {
        background-color: var(--sed-warm-white-color) !important;
        color: var(--sed-dynamic-black-color) !important;
        border: 1px solid var(--sed-dynamic-black-color) !important;
        height: var(--mat-button-filled-container-height);
        border-radius: 20px;
        padding: 0 20px;
        transition: all 0.3s ease;

        &:hover:not(:disabled) {
          background-color: var(--sed-sedgwick-green-color) !important;
          color: var(--sed-dynamic-black-color) !important;
        }
      }

      .low-emphasis:focus {
        color: var(--sed-dynamic-black-color);
        outline: 2px solid var(--sed-dynamic-black-color) !important;
      }

      .low-emphasis-disabled {
        background-color: white;
        color: var(--sed-dynamic-black-color);
        border: 0px solid #dcdcdc;
      }

      .medium-emphasis {
        background-color: var(--color-slate);
        color: white;
      }

      .medium-emphasis-disabled {
        background-color: #dcdcdc;
        color: #888888;
      }

      .medium-emphasis:hover {
        background-color: var(--color-slate-500);
        color: white;
      }

      .text:focus {
      }
    `,
    ],
    standalone: false
})
export class ButtonComponent {
  @Input()
  emphasis: Emphasis = 'Low';

  @Input()
  text: string;

  @Input()
  icon: string;

  @Input()
  label: string;

  @Input()
  type: InputType = 'button';

  @Input()
  disabled = false;

  @Input()
  disableWhenSubmit = false;

  @Input()
  loading = false;

  @Input()
  arialabel: string;

  @Input()
  role: string = 'button';

  @Input()
  id: string;

  @Input()
  showSpinner: boolean = true;

  translationRequest = new TranslationRequest({
		language: sessionStorage.getItem('languagepreference'),
		key: null,
		contNum: 0,
		tableName: null,
		primaryKey: null,
		primaryValue: null,
		lob: null,
		group: 'Shared',
		subGroup: 'Shared',
	});

  /**
   * Setting pointer-events is needed to prevent click events from
   * firing when the button is disabled or loading.
   */
  ngAfterViewInit() {
    this.wcagCompliance();
  }
  wcagCompliance() {
    document.querySelectorAll('button[mat-flat-button]').forEach((el) => {
      el.classList.remove('mat-mdc-unelevated-button');
    });
  }
  @HostBinding('style.pointer-events') get pEvents(): string {
    if (this.disabled || this.loading) {
      return 'none';
    }
    return 'auto';
  }
}

export type InputType = 'button' | 'submit';
